import React from "react";

export const NovoBadge: React.FC<{ className?: string }> = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 bg-gradient-to-r from-yellow-400 to-amber-500 text-black text-[10px] font-extrabold px-2 py-0.5 rounded-full shadow-md animate-pulse ${className}`}
  >
    ✨ NOVO
  </span>
);
